
import ErrorPage from './errorpage'

export default ErrorPage;